import Loading from "@/components/Loading";
import LoginMetaTags from "@/components/MetaTags/LoginMetaTags";
import { useAuthLoginMutation, useAuthUserQuery, usePreviousPath } from "@/hooks";
import routes from "@/lib/routes";
import processStyles from "@/styles/Process.module.scss";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useCallback } from "react";
import { v4 as uuidv4 } from "uuid";
import classnames from "classnames";
import Image from "next/legacy/image";
import Link from "next/link";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const LoginForm = dynamic(() => import("@/components/Form/index").then(mod => mod.LoginForm), {
  loadableGenerated: {
    webpack: () => [require.resolveWeak("@/components/Form/index")]
  }
});
export default function Login() {
  var _router$query;
  const router = useRouter();
  const code = router === null || router === void 0 || (_router$query = router.query) === null || _router$query === void 0 ? void 0 : _router$query.code;
  const prevPath = usePreviousPath();
  const {
    data
  } = useAuthUserQuery();
  const user = data === null || data === void 0 ? void 0 : data.user;
  // ログイン済みで簡単ログインコードが存在する場合は簡単ログイン認証画面にリダイレクト
  if (!!user && !!code) {
    window.location.href = routes.deviceActivation(code);
  }
  const [login, {
    loading,
    error
  }] = useAuthLoginMutation({
    onCompleted: _ref => {
      let {
        login
      } = _ref;
      if (login) {
        const rejectPaths = ["/400", "/401", "/500", "/signup", "/password_remind", "/myskp"];
        const rejected = rejectPaths.filter(path => {
          if (prevPath) {
            // prevPathがrejectPathsのいずれかに該当したらtrueを返す
            return !!~prevPath.indexOf(path);
          } else {
            return true;
          }
        });
        if (!!code) {
          window.location.href = routes.deviceActivation(code);
        } else if (rejected.length > 0) {
          window.location.href = routes.home;
        } else {
          window.location.href = prevPath;
        }
      }
    },
    onError: e => {
      console.log(e.message);
    }
  });
  const onSubmit = useCallback(data => {
    return login({
      variables: {
        loginid: data.loginid,
        password: data.password,
        rememberme: !!data.rememberme,
        signature: uuidv4()
      }
    });
  }, []);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [loading && /*#__PURE__*/_jsx(Loading, {
      fixed: true
    }), /*#__PURE__*/_jsx(LoginMetaTags, {}), /*#__PURE__*/_jsx("div", {
      className: classnames(processStyles.container, processStyles.login),
      children: /*#__PURE__*/_jsxs("div", {
        className: processStyles.inner,
        children: [/*#__PURE__*/_jsx("h2", {
          className: `${processStyles.heading} ${processStyles.withoutSteps}`,
          children: "\u30ED\u30B0\u30A4\u30F3"
        }), /*#__PURE__*/_jsx("div", {
          children: /*#__PURE__*/_jsx(LoginForm, {
            onSubmit: onSubmit,
            error: error
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: processStyles.caution,
          children: [/*#__PURE__*/_jsxs("h3", {
            children: [/*#__PURE__*/_jsx("span", {
              className: processStyles.iconCaution,
              children: /*#__PURE__*/_jsx(Image, {
                src: "/images/icon_alert.png",
                alt: "icon_alert",
                layout: "responsive",
                width: 16,
                height: 16
              })
            }), "\u91CD\u8981\u306A\u304A\u77E5\u3089\u305B"]
          }), /*#__PURE__*/_jsx("p", {
            children: "2025\u5E745\u670813\u65E5\u3092\u3082\u3061\u3001My\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3067\u306E\u767B\u9332\u30FB\u30ED\u30B0\u30A4\u30F3\u304C\u3067\u304D\u306A\u304F\u306A\u308A\u307E\u3059\u3002"
          }), /*#__PURE__*/_jsx("p", {
            children: "My\u30B9\u30AB\u30D1\u30FC\uFF01ID\u3067\u306E\u30ED\u30B0\u30A4\u30F3\u5229\u7528\u4E2D\u306E\u65B9\u306F\u767B\u9332\u6642\u306ESPOOX ID\u3088\u308A\u30ED\u30B0\u30A4\u30F3\u3057\u3066\u304F\u3060\u3055\u3044\u3002"
          }), /*#__PURE__*/_jsxs("p", {
            children: ["SPOOX ID\u30FB\u30D1\u30B9\u30EF\u30FC\u30C9\u306B\u3064\u3044\u3066\u306F", /*#__PURE__*/_jsx(Link, {
              href: "/static/feature/constant/myskpguide",
              className: "mainColor underline",
              children: "\u3053\u3061\u3089"
            }), "\u3067\u3054\u78BA\u8A8D\u304F\u3060\u3055\u3044\u3002"]
          })]
        })]
      })
    })]
  });
}
Login.layout = "NoHeaderLayout";